// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__i2ic0","title":"Images90_title__3kn1H","images":"Images90_images__1R-3C"};